import { useEffect } from "react"

const ChatbaseWidget = () => {
  useEffect(() => {
    const excludedPaths = [
      "/fr/demo-redirect",
      "/fr/product-tour", // couvre /product-tour, /product-tour-resume, /product-tour-merci
      "/de/demo-weiterleitung",
      "/de/product-tour" // couvre /product-tour-danke, /product-tour-fortsetzen
      // Ajoutez d'autres URLs ici
    ]

    // Check if current path is excluded
    const currentPath = window.location.pathname
    const isExcluded = excludedPaths.some(excludedPath =>
      currentPath.startsWith(excludedPath)
    )

    if (isExcluded) return

    // Chatbase bot ID for each locale that has a chatbot
    const chatbotIdsByLocale = {
      fr: "3VolwsdYzKhdhRlLUb_d0",
      it: "1VoUFKI7n2ki2QUP8G2oL",
      "en-us": "q9psIQVYq2aEYjWyoRe6k",
      de: "NO3UVa9c3YIA_v0Le51sT",
      es: "kG3JHk8JXhCymMdjc79LB",
      en: "1X1b7GrabCqsE5ZVJOuMk"
    }

    // Detect locale from the first URL segment and bail if it has no chatbot
    const locale = window.location.pathname.split("/")[1]?.toLowerCase()
    const idChat = chatbotIdsByLocale[locale]
    if (!idChat) return

    // If chatbase is not initialized, create a proxy
    if (!window.chatbase || window.chatbase("getState") !== "initialized") {
      window.chatbase = (...args) => {
        if (!window.chatbase.q) window.chatbase.q = []
        window.chatbase.q.push(args)
      }
      window.chatbase = new Proxy(window.chatbase, {
        get(target, prop) {
          if (prop === "q") return target.q
          return (...args) => target(prop, ...args)
        }
      })
    }

    // Delay Chatbase loading to avoid blocking initial render
    // Load after 5s idle or on first user interaction, whichever comes first
    let loaded = false
    const loadChatbase = () => {
      if (loaded) return
      loaded = true
      if (!document.getElementById(`${idChat}`)) {
        const script = document.createElement("script")
        script.src = "https://www.chatbase.co/embed.min.js"
        script.id = idChat
        script.domain = "www.chatbase.co"
        script.async = true
        document.body.appendChild(script)
      }
      // Remove interaction listeners once loaded
      ;["scroll", "mousemove", "touchstart", "keydown"].forEach(evt =>
        window.removeEventListener(evt, loadChatbase)
      )
    }

    // Load on first user interaction
    ;["scroll", "mousemove", "touchstart", "keydown"].forEach(evt =>
      window.addEventListener(evt, loadChatbase, { once: true, passive: true })
    )

    // Fallback: load after 5 seconds regardless
    const timer = setTimeout(loadChatbase, 5000)

    return () => {
      clearTimeout(timer)
      ;["scroll", "mousemove", "touchstart", "keydown"].forEach(evt =>
        window.removeEventListener(evt, loadChatbase)
      )
    }
  }, [])
  return null
}

export default ChatbaseWidget
